import moment from 'moment';
import { any } from 'ramda';

import { toMoment } from 'utils/dateUtils';

export const createEmailSubjectLine = ({ firstName, lastName, businessName }) =>
  `${firstName} ${lastName} from ${businessName} wants to collaborate in Paperless Parts`;

export const findFarthestExpiration = (expirationDates) => {
  if (any((expirationDate) => expirationDate === null)(expirationDates)) {
    return null;
  }

  const moments = expirationDates.map((dateString) => toMoment(dateString));
  return moment.max(moments);
};
